import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from '@/contexts/AuthContext';

export interface EmailAccountDisplayInfo {
  id: string;
  email_address: string;
  provider: string; // e.g., 'gmail', 'outlook'
  sync_enabled: boolean;
}

const fetchEmailAccounts = async (userId: string): Promise<EmailAccountDisplayInfo[]> => {
  if (!userId) return [];
  const { data, error } = await supabase
    .from("email_accounts")
    .select("id, email_address, provider, sync_enabled")
    .eq("user_id", userId)
    .order("email_address", { ascending: true });

  if (error) {
    console.error("Error fetching email accounts:", error);
    throw error;
  }
  return data || [];
};

export const useEmailAccounts = () => {
  const { session } = useAuth();
  const userId = session?.user?.id;

  return useQuery<EmailAccountDisplayInfo[], Error>({
    queryKey: ["emailAccounts", userId],
    queryFn: () => {
      if (!userId) return Promise.resolve([]);
      return fetchEmailAccounts(userId);
    },
    enabled: !!userId,
  });
};
